// extracted by mini-css-extract-plugin
export default {"wrapper":"Icon_wrapper__cFtg6","icon":"Icon_icon__zcHyd","label":"Icon_label__2G9k9"};